import { Injectable, Injector } from '@angular/core';
import { NavigationEnd } from '@angular/router';

// import { initDynamicLayoutUrl } from '@bitf/utils/bitf-responsive.utils';

import { BitfAppSessionService } from '@bitf/services/app-session/bitf-app-session.service';
import { BitfLogDnaSenderService } from '@bitf/services/logger/bitf-log-dna-sender.service';
import { BitfPwaService } from '@bitf/services/pwa/bitf-pwa.service';
import { BitfTagManagerService } from '@bitf/services/tag-manager/bitf-tag-manager.service';
import { ResponsiveService } from '@services';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppSessionService extends BitfAppSessionService {
  private navigationHistory: string[] = [];

  constructor(
    private bitfTagManagerService: BitfTagManagerService,
    private bitfLogDnaSenderService: BitfLogDnaSenderService,
    private responsiveService: ResponsiveService,
    protected bitfPwaService: BitfPwaService,
    protected injector: Injector
  ) {
    super(injector);
  }

  async init() {
    await super.init();
    // NOTE: At this point translations are already loaded

    // NOTE: needed for mobile/desktop routing support
    //(this.router, this.storeService);

    this.initBreakpointListener();
    this.responsiveService.init();

    // this.bitfTagManagerService.init();

    // this.bitfMetadataService.setDefaultDescription();

    // PWA
    // this.bitfPwaService.initOnlineChecker();
    // this.bitfPwaService.showDefaultOnlineStateChangeToast();
    // if (environment.registerServiceWorker) {
    //   this.bitfPwaService.init();

    //   this.bitfPwaService.initManifest();

    //   this.bitfPwaService.initSwUpdate();
    //   this.bitfPwaService.handleSwUpdate();

    //   this.bitfPwaService.initBeforeInstallPrompt();
    //   this.bitfPwaService.checkForBeforeInstallPromptEvent();
    // }

    this.handleNavigationChange();
  }

  private handleNavigationChange() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.navigationHistory.push(event.urlAfterRedirects);
    });
  }

  canNavigateBack(): boolean {
    return this.navigationHistory.length > 1;
  }

  navigateBack(defaultRoute: string = '/'): void {
    if (this.canNavigateBack()) {
      this.navigationHistory.pop();
      const previousUrl = this.navigationHistory.pop();
      this.router.navigateByUrl(previousUrl!);
    } else {
      this.router.navigateByUrl(defaultRoute);
    }
  }

  initLogSender() {
    this.bitfLogDnaSenderService.init();
  }
}
